import { AdminRole, EmployeeRole, SupportRole } from 'constants/enums/roles';
import User from 'types/user';
import { RoleFilter, UserListFilterValues } from './userList.types';

export const roleFilterOptions: { label: string; value: RoleFilter }[] = [
  { label: 'Todos', value: 'all' },
  { label: 'Administrador', value: AdminRole },
  { label: 'Soporte', value: SupportRole },
  { label: 'Empleado', value: EmployeeRole },
];

const matchesSearch = (user: User, searchValue: string) => {
  const normalizedSearchValue = searchValue.trim().toLowerCase();
  if (!normalizedSearchValue) return true;

  return [user.idEmployee, user.email, user.name, user.lastName].some((value) =>
    value.toLowerCase().includes(normalizedSearchValue)
  );
};

export const filterUsers = (
  users: User[],
  activeContractUserIds: ReadonlySet<string>,
  filters: UserListFilterValues
) =>
  users.filter((user) => {
    const matchesVisibility = filters.showMissingScheduleUsers
      ? activeContractUserIds.has(user._id)
      : filters.showInactiveUsers || user.status;
    const matchesRole = filters.role === 'all' || user.role === filters.role;

    return (
      matchesVisibility &&
      matchesRole &&
      matchesSearch(user, filters.searchValue)
    );
  });
